<template>
    <div>
    <v-card class="elevation-1"> 
             <v-data-table
                                class="va-table"
                                :headers="headers"
                                :items-per-page="10000"
                                hide-default-footer
                                :items="CurrentItems"
                                disable-sort
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>
                                              <v-icon @click="sales=item, state='update', form=true" left color="warning" small>mdi-pencil</v-icon>
                                            {{ item.name }}
                                            </td>
                                           <td>
                                                {{ $money(item.price) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.kilos) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.service_charge) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(item.trucking_fee) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(($IsNum(item.price) * $IsNum(item.kilos)) +  $IsNum(item.trucking_fee) + $IsNum(item.service_charge)) }}
                                            </td>
                                    </tr>
                                     <tr class="title">
                                            <td>
                                           
                                            </td>
                                           <td>
                                               
                                            </td>
                                            <td class="text-right">
                                                {{ $money(KILOS) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(SERVICE_CHARGE) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(TRUCKING_FEE) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $money(TOTAL_AMOUNT) }}
                                            </td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
    </v-card>
    </div>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    query: {
        type: Object,
        default: ()=>{ return {}}
    }
  },
  data: () => ({
      valid: true,
      CurrentItems:[],
       headers:[
            {text: 'Fish', value: 'name', sortable: false},
            {text: 'Price/Kg', value: 'price', sortable: false},
            {text: 'Weight(Kg)', value: 'kilos', sortable: false, align: 'right'},
             {text: 'SC', value: 'service_charge', sortable: false, align: 'right'},
            {text: 'Trucking', value: 'trucking_fee', sortable: false, align: 'right'},
            {text: 'Amount',sortable: false, align: 'right'}
        ],
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      AMOUNT() {
          var total = 0
            for(var i =0;i<this.CurrentItems.length;i++) {
              total += this.$IsNum(this.CurrentItems[i].price) * this.$IsNum(this.CurrentItems[i].kilos)
          }
          return total
      },
      KILOS() {
          var total = 0
            for(var i =0;i<this.CurrentItems.length;i++) {
              total += this.$IsNum(this.CurrentItems[i].kilos)
          }
          return total
      },
      SERVICE_CHARGE() {
          var total = 0
            for(var i =0;i<this.CurrentItems.length;i++) {
              total += this.$IsNum(this.CurrentItems[i].service_charge)
          }
          return total
      },
      TRUCKING_FEE() {
          var total = 0
            for(var i =0;i<this.CurrentItems.length;i++) {
              total += this.$IsNum(this.CurrentItems[i].trucking_fee)
          }
          return total
      },
      TOTAL_AMOUNT(){
          return this.AMOUNT + this.SERVICE_CHARGE + this.TRUCKING_FEE
      }
  },
  watch: {
   
  },
  methods: {
     
  }
}
</script>
